export const MEGA_WATT_CONVERSION_FACTOR = 1e6;

export const MIN_TO_HR_CONVERSION_FACTOR = 3.6e6;

export const DEFAULT_FROM_TIME_OPTION = "now";
